export default class Product {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    id: 'string',
    name: 'string',
    //Compatibility
    id: 'any?',
    clientID: 'any?',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
  }
  */
  async createCategory(categoryObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/category/" + categoryObj.id;
    req.body = categoryObj;
    return await req.exec();
  }
  async updateCategory(categoryObj) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = "/category/" + categoryObj.id;
    req.body = categoryObj;
    return await req.exec();
  }
  async deleteCategory(categoryID) {
    const req = await this.api.newBaseRequest("DELETE");
    req.path = "/category/" + categoryID;
    return await req.exec();
  }
  async getCategory(categoryID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/category/" + categoryID;
    return await req.exec();
  }
  async getAllClientCategories() {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/categories/";
    return await req.exec();
  }
  async getAllCategories() {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/categories/all";
    return await req.exec();
  }
}
